import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MainService } from 'src/app/services/main.service';
import Swal from 'sweetalert2';
import { StoreService } from 'src/app/services/store.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-stores-attributes-values-list-upload',
  templateUrl: './stores-attributes-values-list-upload.component.html',
  styleUrls: ['./stores-attributes-values-list-upload.component.scss']
})
export class StoresAttributesValuesListUploadComponent implements OnInit {

  bodyForm : FormData = new FormData(); 
  form!: FormGroup;
  fileControl = new FormControl([]);  
  

  constructor(
    private fb : FormBuilder,
    private main: MainService,
    private store : StoreService,
    private dialogRef: MatDialogRef<StoresAttributesValuesListUploadComponent>,
  ) {
    this.loadForm();
  }

  ngOnInit(): void {
  }

  loadForm() {
    this.form = this.fb.group({
      blob : [null, {validators:[Validators.required]}]
    });
  }

  onValueChange(files : any)
  { 
  }

  uploadWarnings : Array<any> = [];
  uploaded : boolean = false;

  uploadFile(){
    Swal.fire({
      title: '¿Esta seguro que desea cargar este archivo? Esto sobreescribirá todos los atributos de sucursales existentes en este archivo y los cambios pendientes de estas sucursales igualmente se sobreescribirán',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar'
    })
  .then((willDelete) => {
    if (willDelete.isConfirmed) {
      if(this.form.value.blob != null && this.form.value.blob?.length!=0){
        this.bodyForm.append("blob", this.form.value.blob[0] as File);    
        this.store.uploadStoresMasiveFile(this.bodyForm).subscribe(
          (result:any) => {
           this.uploadWarnings = result.validaciones;
           this.uploaded = true;
           Swal.fire({
            icon: 'success',
            title: 'Exitoso',
            text: 'El archivo fue cargado con éxito'
          });

          if(this.uploadWarnings.length == 0){
            this.dialogRef.close()
          }


          },
          (err:any) => {
   
            console.log(err);
 
              Swal.fire({
                icon: 'error',
                title: 'Error al cargar el archivo',
                text: 'Ocurrió un error al cargar el archivo.'
              });
            
          }
        );
    }else{
        Swal.fire({
          icon: 'warning',
          title: 'Error',
          html: 'El documento no ha sido adjuntado'
        });
      }
    }
   });


  }

}
